import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=0fd479fb&scoped=true&"
import script from "./BaseLoader.vue?vue&type=script&lang=js&"
export * from "./BaseLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BaseLoader.vue?vue&type=style&index=1&id=0fd479fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd479fb",
  null
  
)

export default component.exports